import React, { useEffect, useState } from "react";

/*
  BAYİ YÖNETİMİ – FINAL (SERVER + DB UYUMLU)
  ✔ Kurum ekle
  ✔ Kurum listele
  ✔ Kurum sil
  ✔ Login / Logout
*/

const API = "https://api.haymestasarim.com/api";

export default function AdminLogin() {


/* ================= NETWORK USERS ================= */
const [networkUsers, setNetworkUsers] = useState([]);
const [networkOpen, setNetworkOpen] = useState(false);

const fetchNetworkUsers = async () => {
  try {
    const res = await fetch(`${API}/admin/network/users`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    if (res.ok) setNetworkUsers(data || []);
  } catch (err) {
    console.error("Network kullanıcıları alınamadı", err);
  }
};


/* ================= ÖDEME TALEPLERİ ================= */
const [odemeTalepleri, setOdemeTalepleri] = useState([]);
const [odemeOpen, setOdemeOpen] = useState(false);

const fetchOdemeTalepleri = async () => {
  try {
    const res = await fetch(`${API}/admin/payout-requests`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    if (res.ok) {
      setOdemeTalepleri(data || []);
    }
  } catch (err) {
    console.error("Ödeme talepleri alınamadı", err);
  }
};


/* ================= PAKET BAŞVURULARI ================= */
const [paketBasvurulari, setPaketBasvurulari] = useState([]);
/* ================= PAKET DETAYLARI ================= */
const [paketDetaylari, setPaketDetaylari] = useState([]);


/* ================= PAKET FİLTRE ================= */
const [paketFilter, setPaketFilter] = useState("Tümü");

/* ================= FİLTRELİ PAKET LİSTESİ ================= */
const filteredPaketler = paketBasvurulari.filter(p => {
  if (paketFilter === "Tümü") return true;
  return p.durum === paketFilter;
});

/* ================= PAKET BAŞVURULARINI GETİR ================= */
const fetchPaketBasvurulari = async () => {
  try {
    const res = await fetch(`${API}/admin/paket/basvurular`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const data = await res.json();

    if (res.ok) {
  setPaketBasvurulari(data.basvurular || []);
}


  } catch (err) {
    console.error("Paket başvuruları alınamadı", err);
  }
};


/* 🔽 BURAYA EKLE */
const [token, setToken] = useState(() =>
  localStorage.getItem("admin_token")
);


/* ===== MOBILE FIX (SADECE CSS) ===== */
useEffect(() => {
  const mobileStyle = document.createElement("style");
  mobileStyle.innerHTML = `
    @media (max-width: 768px) {
      .admin-layout {
        display: flex !important;
        flex-direction: column !important;
      }

      .admin-card {
        width: 100% !important;
      }
    }
  `;
  document.head.appendChild(mobileStyle);

  return () => {
    document.head.removeChild(mobileStyle);
  };
}, []);

  /* LOGIN */
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");


function kalanGun(bitisTarihi) {
  const bugun = new Date();
  const bitis = new Date(bitisTarihi);
  const fark = Math.ceil((bitis - bugun) / (1000 * 60 * 60 * 24));
  return fark;
}

function paketBitisTarihi(baslangicTarihi) {
  const baslangic = new Date(baslangicTarihi);
  baslangic.setDate(baslangic.getDate() + 365);
  return baslangic;
}

  /* DATA */
  const [kurumlar, setKurumlar] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);


  /* FORM */
  const [ad, setAd] = useState("");
  const [code, setCode] = useState("");
  const [shortCode, setShortCode] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPassword, setAdminPassword] = useState("");


// ✅ YENİ EKLENENLER
const [kategoriId, setKategoriId] = useState("");
const [il, setIl] = useState("");
const [ilce, setIlce] = useState("");

// ✅ STATE'LER
const [cities, setCities] = useState([]);
const [districts, setDistricts] = useState([]);
const [city, setCity] = useState("");
const [district, setDistrict] = useState("");

// ✅ İLLERİ GETİR
useEffect(() => {
  fetch(`${API}/auth/locations/tr/cities`)
    .then(r => r.json())
    .then(d => setCities(d || []))
    .catch(err => console.error("CITIES ERROR", err));
}, []);

// ✅ İLÇELERİ GETİR (il seçilince)
useEffect(() => {
  setDistrict("");
  if (!city) {
    setDistricts([]);
    return;
  }
  fetch(`${API}/auth/locations/tr/districts?city_id=${city}`)
    .then(r => r.json())
    .then(d => setDistricts(d || []))
    .catch(err => console.error("DISTRICTS ERROR", err));
}, [city]);


  /* ================= LOGIN ================= */
  const login = async () => {
    setLoading(true);
    setMessage(null);

    try {
      const res = await fetch(`${API}/giris`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (res.ok && data?.token) {
        localStorage.setItem("admin_token", data.token);
        setToken(data.token);
      } else {
        setMessage({ type: "error", text: "Giriş başarısız" });
      }
    } catch {
      setMessage({ type: "error", text: "Sunucuya ulaşılamadı" });
    } finally {
      setLoading(false);
    }
  };

  /* ================= LOGOUT ================= */
  const logout = () => {
    localStorage.removeItem("admin_token");
    setToken(null);
  };

  /* ================= LIST ================= */
  const fetchKurumlar = async () => {
    try {
      const res = await fetch(`${API}/admin/kurumlar`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const json = await res.json();
      setKurumlar(json.data || []);
    } catch {
      setMessage({ type: "error", text: "Bayiler listelenemedi" });
      setKurumlar([]);
    }
  };

useEffect(() => {
  if (token) {
    fetchKurumlar();       // kurumlar
    fetchPaketBasvurulari(); 
    fetchOdemeTalepleri();
 fetchNetworkUsers();
  }
}, [token]);


/* ================= PAKET ONAYLA ================= */
const onaylaPaket = async (b) => {
  try {
const res = await fetch(`${API}/admin/paket/onayla/${b.id}`, {
  method: "POST",
  headers: {
    Authorization: `Bearer ${token}`
  }
});


    if (!res.ok) {
      alert("Paket onaylanamadı");
      return;
    }

    fetchPaketBasvurulari(); // tabloyu yenile
  } catch (err) {
    console.error("Onay hatası", err);
  }
};



  /* ================= CREATE ================= */
  const createKurum = async () => {
    if (!ad || !code || !shortCode || !adminEmail || !adminPassword) {
      setMessage({ type: "error", text: "Tüm alanlar zorunlu" });
      return;
    }

    if (!/^7\d{3}$/.test(code) || !/^7\d{3}$/.test(shortCode)) {
      setMessage({
        type: "error",
        text: "Kurum kodu 7000–7999 arasında olmalı",
      });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      const res = await fetch(`${API}/admin/kurumlar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ad,
          code,
          short_code: shortCode,
          email: adminEmail,
          sifre: adminPassword,
 kategori_id: kategoriId ? Number(kategoriId) : null,
il: city ? Number(city) : null,
ilce: district ? Number(district) : null,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage({ type: "error", text: data?.message || "Kayıt başarısız" });
        return;
      }

      setMessage({ type: "success", text: "✅ Bayi başarıyla oluşturuldu" });

      /* Form reset */
      setAd("");
      setCode("");
      setShortCode("");
      setAdminEmail("");
      setAdminPassword("");

      /* Listeyi DB’den tekrar al (en sağlam yol) */
      fetchKurumlar();

    } catch {
      setMessage({ type: "error", text: "Sunucu hatası" });
    } finally {
      setLoading(false);
    }
  };

  /* ================= DELETE ================= */
  const deleteKurum = async (oldId) => {
    if (!oldId) {
      setMessage({ type: "error", text: "Kurum ID bulunamadı" });
      return;
    }

    if (!window.confirm("Bu bayiyi tamamen silmek istiyor musun?")) return;

    await fetch(`${API}/admin/kurumlar/${oldId}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });

    fetchKurumlar();
  };



/* ================= PANEL USER DELETE ================= */
const deletePanelUser = async (panelUserId) => {
  if (!window.confirm("Bu kullanıcıyı networkten çıkarmak istiyor musun?")) return;

  try {
    const res = await fetch(
      `${API}/admin/network/remove-user/${panelUserId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      alert("Kullanıcı çıkarılamadı");
      return;
    }

  } catch (err) {
    console.error("Panel user silme hatası", err);
  }
};
/* ================= NETWORK USER DELETE ================= */
const deactivateNetworkUser = async (userId) => {
  if (!window.confirm("Bu network kullanıcısı sistemden çıkarılsın mı?"))
    return;

  const res = await fetch(
    `${API}/admin/network/deactivate-user/${userId}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ status: "left" })
    }
  );

  if (!res.ok) {
    alert("Network kullanıcısı silinemedi");
    return;
  }

  fetchNetworkUsers();
};

  /* ================= LOGIN UI ================= */
  if (!token) {
    return (
      <div style={styles.loginPage}>
        <div style={styles.loginCard}>
          <h2>BAYİ YÖNETİMİ</h2>
          <input style={styles.input} placeholder="E-posta" onChange={e => setEmail(e.target.value)} />
          <input style={styles.input} type="password" placeholder="Şifre" onChange={e => setPassword(e.target.value)} />
          <button style={styles.primaryBtn} onClick={login}>
            {loading ? "Bekleyin..." : "Giriş Yap"}
          </button>
        </div>
      </div>
    );
  }

  /* ================= FILTER ================= */
const filtered = kurumlar
  // 🔴 PANEL USER SATIRLARINI AT
  .filter(k => k.code && k.short_code)
  // 🔍 ARAMA
  .filter(k =>
    `${k.ad} ${k.code}`.toLowerCase().includes(search.toLowerCase())
  );

  /* ================= PANEL ================= */
  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h1>BAYİ YÖNETİMİ</h1>
        <button style={styles.logoutBtn} onClick={logout}>Çıkış</button>
      </div>

      {message && (
        <div style={{
          ...styles.message,
          background: message.type === "error" ? "#fee2e2" : "#dcfce7",
          color: message.type === "error" ? "#991b1b" : "#166534"
        }}>
          {message.text}
        </div>
      )}

<div style={styles.layout} className="admin-layout">
<div style={styles.card} className="admin-card">
          <h3>Yeni Bayi Ekle</h3>
          <input style={styles.input} placeholder="Kurum Adı" value={ad} onChange={e => setAd(e.target.value)} />
          <input style={styles.input} placeholder="Kurum Kodu" value={code} onChange={e => setCode(e.target.value)} />
          <input style={styles.input} placeholder="Short Code" value={shortCode} onChange={e => setShortCode(e.target.value)} />
          <input style={styles.input} placeholder="Admin E-posta" value={adminEmail} onChange={e => setAdminEmail(e.target.value)} />
          <input style={styles.input} placeholder="Admin Şifre" value={adminPassword} onChange={e => setAdminPassword(e.target.value)} />

{/* ✅ KATEGORİ */}
<select
  style={styles.input}
  value={kategoriId}
  onChange={e => setKategoriId(e.target.value)}
>
  <option value="">Kategori Seç</option>
  <option value="1">Sağlık</option>
  <option value="2">Eğitim</option>
  <option value="3">Restoran</option>
  <option value="4">Spor</option>
  <option value="5">STK</option>
  <option value="6">Finans</option>
  <option value="7">Teknoloji</option>
  <option value="8">Turizm</option>
  <option value="9">Danışmanlık</option>
  <option value="10">Emlak</option>
  <option value="11">Hizmet</option>
  <option value="12">Üretim</option>
  <option value="13">Otomotiv</option>
  <option value="14">Medya</option>
  <option value="15">Enerji</option>
  <option value="16">Kişisel Gelişim</option>
  <option value="17">Diğer</option>
</select>

{/* ✅ BURAYA İL DROPDOWN - ESKİ İL INPUT'UNU SİL */}
<select
  style={styles.input}
  value={city}
  onChange={e => setCity(e.target.value)}
>
  <option value="">İl Seçiniz</option>
  {cities.map(c => (
    <option key={c.id} value={c.id}>{c.name}</option>
  ))}
</select>

{/* ✅ BURAYA İLÇE DROPDOWN - ESKİ İLÇE INPUT'UNU SİL */}
<select
  style={styles.input}
  value={district}
  disabled={!districts.length}
  onChange={e => setDistrict(e.target.value)}
>
  <option value="">İlçe Seçiniz</option>
  {districts.map(d => (
    <option key={d.id} value={d.id}>{d.name}</option>
  ))}
</select>

          <button style={styles.primaryBtn} onClick={createKurum}>
            {loading ? "Kaydediliyor..." : "Kaydet"}
          </button>
        </div>

    <div style={styles.card}>
  <h3>Bayiler ({filtered.length})</h3>

  <input
    style={styles.input}
    placeholder="Bayi ara..."
    value={search}
    onChange={e => setSearch(e.target.value)}
  />

  {filtered.map(k => (
    <details key={k.old_id} style={styles.accordion}>
{console.log("KURUM:", k.code, "ADMIN USER ID:", k.admin_user_id)}

      <summary style={styles.summary}>
        <b>{k.code}</b> — {k.ad}
      </summary>

      <div style={styles.detail}>
        <div><b>ID:</b> {k.old_id}</div>
        <div><b>Short Code:</b> {k.short_code}</div>

        <button
          style={styles.deleteBtn}
          onClick={() => deleteKurum(k.old_id)}
        >
          Bayiyi Sil
        </button>

       </div>
    </details>
  ))}
</div>
</div>
      
      {/* ================= KURUMSAL PAKET BAŞVURULARI ================= */}
      <div style={{ marginTop: 40 }}>
        <div style={styles.card}>
<h3>📦 Paket Başvuruları (Kurumsal)</h3>

<div style={{ display: "flex", gap: 10, margin: "10px 0 20px" }}>
  {["Tümü", "Beklemede", "Onaylandı"].map(f => (
    <button
      key={f}
      onClick={() => setPaketFilter(f)}
      style={{
        padding: "8px 14px",
        borderRadius: 8,
        border: "none",
        cursor: "pointer",
        fontWeight: 700,
        background:
          paketFilter === f
            ? "#2563eb"
            : "#e5e7eb",
        color:
          paketFilter === f
            ? "#fff"
            : "#111827"
      }}
    >
      {f}
    </button>
  ))}
</div>

          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#f1f5f9", textAlign: "left" }}>
                  <th style={styles.th}>Başvuran</th>
                  <th style={styles.th}>Referans</th>
 <th style={styles.th}>Paket</th>
<th style={styles.th}>Başlangıç</th>
<th style={styles.th}>Bitiş</th>
<th style={styles.th}>Kalan Süre</th>
<th style={styles.th}>Durum</th>

                  <th style={styles.th}>İşlem</th>
                </tr>
              </thead>
<tbody>
{filteredPaketler.map(b => {
 const baslangic = b.baslangic_tarihi
  ? new Date(b.baslangic_tarihi)
  : null;

const bitis = b.bitis_tarihi
  ? new Date(b.bitis_tarihi)
  : null;

const gun = bitis ? kalanGun(bitis) : null;



    return (
      <tr key={b.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
        <td style={styles.td}>{b.ad}</td>
        <td style={styles.td}>{b.referans}</td>
        <td style={styles.td}><b>{b.paket}</b></td>

      <td style={styles.td}>
  {baslangic ? baslangic.toLocaleDateString("tr-TR") : "-"}
</td>

<td style={styles.td}>
  {bitis ? bitis.toLocaleDateString("tr-TR") : "-"}
</td>


 <td style={styles.td}>
  {gun !== null && (
    <>
      {/* AKTİF PAKET */}
      {gun > 0 && (
        <span style={{
          padding: "4px 10px",
          borderRadius: 20,
          fontWeight: 700,
          background:
            gun <= 3 ? "#fecaca" :
            gun <= 7 ? "#fde68a" :
            gun <= 30 ? "#bfdbfe" : "#dcfce7",
          color:
            gun <= 3 ? "#991b1b" :
            gun <= 7 ? "#92400e" :
            gun <= 30 ? "#1e40af" : "#166534"
        }}>
          {gun} gün kaldı
        </span>
      )}

      {/* UPGRADE EDİLMİŞ PAKET */}
      {gun <= 0 && b.upgraded === true && (
        <span style={{
          padding: "4px 10px",
          borderRadius: 20,
          fontWeight: 700,
          background: "#dbeafe",
          color: "#1e40af"
        }}>
          🔵 Paket yükseltildi
        </span>
      )}

      {/* GERÇEKTEN SÜRESİ DOLMUŞ */}
      {gun <= 0 && !b.upgraded && (
        <span style={{
          padding: "4px 10px",
          borderRadius: 20,
          fontWeight: 700,
          background: "#fecaca",
          color: "#991b1b"
        }}>
          🔴 Süresi doldu
        </span>
      )}
    </>
  )}
</td>


   <td style={styles.td}>{b.durum}</td>

<td style={styles.td}>
  {b.durum === "Beklemede" && (
    <button
      style={styles.approveBtn}
      onClick={() => onaylaPaket(b)}
    >
      Onayla
    </button>
  )}
</td>
      </tr>
    );
  })}
</tbody>
</table>
</div>
</div>



{/* ================= ÖDEME TALEPLERİ (AKORDİYON) ================= */}
<div style={{ marginTop: 40 }}>
  <div style={styles.card}>
    <div
      onClick={() => setOdemeOpen(!odemeOpen)}
      style={{
        display: "flex",
        justifyContent: "space-between",
        cursor: "pointer",
        fontWeight: 800,
        fontSize: 18
      }}
    >
      <span>💸 Ödeme Talepleri (Referans Kazanç)</span>
      <span>{odemeOpen ? "−" : "+"}</span>
    </div>

    {odemeOpen && (
      <div style={{ marginTop: 20, overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f1f5f9" }}>
              <th style={styles.th}>Kullanıcı</th>
              <th style={styles.th}>Tutar</th>
              <th style={styles.th}>Talep Tarihi</th>
              <th style={styles.th}>Durum</th>
              <th style={styles.th}>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {odemeTalepleri.map(o => (
              <tr key={o.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                <td style={styles.td}>{o.user_name}</td>
                <td style={styles.td}><b>{Number(o.amount).toFixed(2)} ₺</b></td>
                <td style={styles.td}>
                  {new Date(o.created_at).toLocaleDateString("tr-TR")}
                </td>
                <td style={styles.td}>{o.status}</td>
                <td style={styles.td}>
                  {o.status === "requested" && (
                    <button
                      style={styles.approveBtn}
                      onClick={async () => {
                        await fetch(`${API}/admin/payout-approve/${o.id}`, {
                          method: "POST",
                          headers: { Authorization: `Bearer ${token}` }
                        });
                        fetchOdemeTalepleri();
                      }}
                    >
                      Ödemeyi Onayla
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
</div>


{/* ================= NETWORK KULLANICILARI ================= */}
<div style={{ marginTop: 40 }}>
  <div style={styles.card}>
    <div
      onClick={() => setNetworkOpen(!networkOpen)}
      style={{
        display: "flex",
        justifyContent: "space-between",
        cursor: "pointer",
        fontWeight: 800,
        fontSize: 18
      }}
    >
      <span>🌐 Network Kullanıcıları</span>
      <span>{networkOpen ? "−" : "+"}</span>
    </div>

    {networkOpen && (
      <div style={{ marginTop: 20, overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f1f5f9" }}>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>Ad Soyad</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Durum</th>
              <th style={styles.th}>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {networkUsers.map(u => (
              <tr key={u.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                <td style={styles.td}>{u.id}</td>
<td style={styles.td}>{u.kurum_adi}</td>
                           <td style={styles.td}>{u.email}</td>
                <td style={styles.td}>{u.network_status}</td>
                <td style={styles.td}>
                  <button
                    style={{
                      ...styles.deleteBtn,
                      background: "#dc2626"
                    }}
                    onClick={() => deactivateNetworkUser(u.id)}
                  >
                    Network’ten Çıkar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
</div>



</div>



</div>
  );
}

/* ================= STYLES ================= */
const styles = {
  th: {
    padding: 12,
    fontWeight: 700,
    fontSize: 14,
    borderBottom: "2px solid #e5e7eb"
  },
  td: {
    padding: 12,
    fontSize: 14
  },
  approveBtn: {
    padding: "8px 14px",
    borderRadius: 8,
    background: "#16a34a",
    color: "#fff",
    border: "none",
    fontWeight: 700,
    cursor: "pointer"
  },


  page: { minHeight: "100vh", padding: 24, background: "#f8fafc" },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 },
  layout: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 },
  card: { background: "#fff", borderRadius: 14, padding: 20, boxShadow: "0 10px 30px rgba(0,0,0,.08)" },
  input: { width: "100%", padding: 12, borderRadius: 8, border: "1px solid #d1d5db", marginBottom: 10 },
  primaryBtn: { width: "100%", padding: 14, borderRadius: 10, background: "#2563eb", color: "#fff", fontWeight: 700, border: "none" },
  deleteBtn: { marginTop: 10, width: "100%", padding: 12, borderRadius: 8, background: "#f97316", color: "#fff", border: "none" },
  logoutBtn: { padding: "10px 16px", borderRadius: 8, background: "#0f172a", color: "#fff", border: "none" },
  accordion: { border: "1px solid #e5e7eb", borderRadius: 8, padding: 10, marginBottom: 8 },
  summary: { cursor: "pointer", fontWeight: 600 },
  detail: { marginTop: 10 },
  message: { padding: 12, borderRadius: 8, marginBottom: 16, fontWeight: 600 },
  loginPage: { minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: "#f1f5f9" },
  loginCard: { background: "#fff", padding: 30, borderRadius: 14, width: 360 }
};

/* =====================================================
   MOBILE RESPONSIVE OVERRIDE
===================================================== */

if (typeof window !== "undefined") {
  const isMobile = window.innerWidth < 768;

  if (isMobile) {

    styles.page.padding = 12;

    styles.layout.gridTemplateColumns = "1fr";

    styles.card.padding = 16;

    styles.header.flexDirection = "column";
    styles.header.alignItems = "flex-start";
    styles.header.gap = 10;

    styles.logoutBtn.width = "100%";

    styles.loginCard.width = "92%";

    styles.th.fontSize = 12;
    styles.td.fontSize = 13;

  }
}

